import PropTypes from "prop-types";
import { gql } from "apollo-boost";

const FILTERS_BY_COUNTRY = gql`
  query getFilters($language: String!) {
    groupQuery {
        entities {
          entityChanged
          entityUuid
          entityLabel
          entityType
          entityCreated
          entityId
          entityBundle
          ... on GroupCountry {
            id
            label
            entityPublished
            fieldGroupMachineName
          }
        }
      }
    filtersByCountry(filter: { langcode: $language }) {
      results {
        ... on NodeFilterByCountry {
          entityLabel
          fieldServicesList {
            entity {
              ... on ParagraphServices {
                fieldLabel {
                  processed
                }
                fieldService {
                  entity {
                    entityLabel
                    tid
                  }
                }
                fieldLink {
                  uri
                  title
                }
              }
            }
          }
          fieldInformativeText {
            value
          }
          fieldAdvancedFilters {
            entity {
              ... on ParagraphOptionsServices {
                fieldGroupType
                fieldOptionsType {
                  entity {
                    entityLabel
                    tid
                  }
                }
              }
              ... on ParagraphOptionsOfficeBranchTypes {
                fieldGroupType
                fieldOptionsType {
                  entity {
                    description {
                      value
                    }
                    entityLabel
                    tid
                  }
                }
              }
            }
          }
          fieldGenericLink {
            title
            url {
              path
            }
          }
          fieldListLink {
            entity {
              ... on ParagraphLinks {
                id
                entityLabel
                fieldMultipleLinks {
                  url {
                    path
                    routed
                  }
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`;

// THIS QUERY GET ALL THE BRANCHES FILTERED BY COUNTRY AND TAXONOMY TERMS
const OFFICE_BRANCHES = gql`
  query officeBranches(
    $langcode: String!
    $tids: String!
    $field_coordinates_proximity: String!
  ) {
    officeBranchesQuery(
      contextualFilter: {
        langcode: $langcode
        tid: $tids
        field_coordinates_proximity: $field_coordinates_proximity
      }
    ) {
      results {
        ... on NodeOfficeBranch {
          entityLabel
          entityId
          fieldLocation
          fieldEmail
          fieldAddress
          fieldMobilePhone
          fieldPrincipalPhone
          fieldDesactivarHorario
          fieldElectricCharger
          fieldDesactivarTelefono
          fieldOfficeBranchImage {
            entity {
              ... on MediaImage {
                fieldMediaImage {
                  alt
                  url
                }
              }
            }
          }
          fieldOfficeBranchType {
            entity {
              entityLabel
            }
          }
          queryFieldServices {
            entities {
              entityLabel
              entityId
            }
          }
          fieldGeographyLocationCr {
            entity {
              entityId
              depthLevel
              parent {
                entity {
                  entityId
                  parent {
                    entity {
                      entityId
                    }
                  }
                }
              }
            }
          }
          fieldGeographyLocationGt {
            entity {
              entityId
              depthLevel
              parent {
                entity {
                  entityId
                  parent {
                    entity {
                      entityId
                    }
                  }
                }
              }
            }
          }
          fieldGeographyLocationHn {
            entity {
              entityId
              depthLevel
              parent {
                entity {
                  entityId
                  parent {
                    entity {
                      entityId
                    }
                  }
                }
              }
            }
          }
          fieldGeographyLocationNi {
            entity {
              entityId
              depthLevel
              parent {
                entity {
                  entityId
                  parent {
                    entity {
                      entityId
                    }
                  }
                }
              }
            }
          }
          fieldGeographyLocationPa {
            entity {
              entityId
              depthLevel
              parent {
                entity {
                  entityId
                  parent {
                    entity {
                      entityId
                    }
                  }
                }
              }
            }
          }
          fieldGeographyLocationSv {
            entity {
              entityId
              depthLevel
              parent {
                entity {
                  entityId
                  parent {
                    entity {
                      entityId
                    }
                  }
                }
              }
            }
          }
          fieldCoordinates {
            lat
            lng
          }
          fieldSchedule {
            day
            starthours
            endhours
          }
          fieldScheduleCounter {
            day
            starthours
            endhours
          }
          fieldDisclamer
        }
      }
    }
  }
`;

const GET_BRANCH_BY_ID = gql`
  query($id: String!) {
    nodeQuery(
      filter: { conditions: { field: "nid", value: [$id], operator: EQUAL } }
    ) {
      entities {
        ... on NodeOfficeBranch {
          ... on NodeOfficeBranch {
            entityLabel
            entityId
            fieldLocation
            fieldEmail
            fieldAddress
            fieldMobilePhone
            fieldPrincipalPhone
            fieldDesactivarHorario
            fieldElectricCharger
            fieldDesactivarTelefono
            fieldOfficeBranchImage {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    alt
                    url
                  }
                }
              }
            }
            fieldOfficeBranchType {
              entity {
                entityLabel
              }
            }
            queryFieldServices {
              entities {
                entityLabel
                entityId
              }
            }
            fieldGeographyLocationCr {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldGeographyLocationGt {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldGeographyLocationHn {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldGeographyLocationNi {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldGeographyLocationPa {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldGeographyLocationSv {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldCoordinates {
              lat
              lng
            }
            fieldSchedule {
              day
              starthours
              endhours
            }
            fieldScheduleCounter {
              day
              starthours
              endhours
            }
            fieldDisclamer
          }
        }
      }
    }
  }
`;

const GET_BRANCH_BY_TITLE = gql`
  query($title: String!) {
    nodeQuery(
      filter: {
        conditions: { field: "title", value: [$title], operator: EQUAL }
      }
    ) {
      entities {
        ... on NodeOfficeBranch {
          ... on NodeOfficeBranch {
            entityLabel
            entityId
            fieldLocation
            fieldEmail
            fieldAddress
            fieldMobilePhone
            fieldPrincipalPhone
            fieldDesactivarHorario
            fieldElectricCharger
            fieldDesactivarTelefono
            fieldOfficeBranchImage {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    alt
                    url
                  }
                }
              }
            }
            fieldOfficeBranchType {
              entity {
                entityLabel
              }
            }
            queryFieldServices {
              entities {
                entityLabel
                entityId
              }
            }
            fieldGeographyLocationCr {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldGeographyLocationGt {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldGeographyLocationHn {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldGeographyLocationNi {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldGeographyLocationPa {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldGeographyLocationSv {
              entity {
                entityId
                depthLevel
                parent {
                  entity {
                    entityId
                    parent {
                      entity {
                        entityId
                      }
                    }
                  }
                }
              }
            }
            fieldCoordinates {
              lat
              lng
            }
            fieldSchedule {
              day
              starthours
              endhours
            }
            fieldScheduleCounter {
              day
              starthours
              endhours
            }
            fieldDisclamer
          }
        }
      }
    }
  }
`;
function Queries(name) {
  switch (name) {
    case "filters":
      return FILTERS_BY_COUNTRY;
    case "branches":
      return OFFICE_BRANCHES;
    case "branchByID":
      return GET_BRANCH_BY_ID;
    case "branchByTitle":
      return GET_BRANCH_BY_TITLE;
  }
}

Queries.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Queries;
